import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, BodySmall, Caption, H2 } from "@components/Typography";
import { Flow, Routes } from "@ctypes";
import { useGoalFlow, useModal, useNavigateToStep } from "@hooks";
import { i18n, Translations } from "@i18n";
import { useStyles } from "./styles";
import { ChildSsnSkipModalProps } from "./types";

export const ChildSsnSkipModal = ({ beneficiaryFirstName }: ChildSsnSkipModalProps) => {
  const { styles } = useStyles();
  const { dismiss } = useModal();
  const navigate = useNavigateToStep();
  const {
    goalProps: { flow },
  } = useGoalFlow();

  const handleSkipToDeposit = () => {
    dismiss();
    if (flow === Flow.AddGoal || flow === Flow.AcceptSharedGoal) {
      navigate(Routes.GoalDeposit);
    } else {
      navigate(Routes.ChildDeposit);
    }
  };

  const props: OverlayProps = {
    horizontal: true,
    cta: {
      primary: {
        title: i18n.t(Translations.ChildSsnSkipModalPrimaryCTA, { name: beneficiaryFirstName }),
        onClick: dismiss,
      },
      secondary: {
        title: i18n.t(Translations.ChildSsnSkipModalSecondaryCTA),
        onClick: handleSkipToDeposit,
      },
    },
  };

  return (
    <Overlay {...props}>
      <Spacing size={SpacingSizes.M} />
      {/* No warning icon: the eyebrow carries the framing instead, which is the whole point of
          the reframe. Everything shares one left edge and one gap. */}
      <div style={styles.content}>
        <Caption style={styles.eyebrow}>{i18n.t(Translations.ChildSsnSkipModalEyebrow)}</Caption>
        <H2>{i18n.t(Translations.ChildSsnSkipModalTitle, { name: beneficiaryFirstName })}</H2>
        <Body style={styles.subtitle}>
          {i18n.t(Translations.ChildSsnSkipModalSubtitle, { name: beneficiaryFirstName })}
        </Body>
        {/* The one consequence worth pulling out of the flow, so the sheet has a single focal
            point rather than competing emphasis in the body. */}
        <div style={styles.note}>
          <span style={styles.noteDot} />
          <BodySmall style={styles.noteText}>
            {i18n.t(Translations.ChildSsnSkipModalTaxNote)}
          </BodySmall>
        </div>
        <Body style={styles.subtitle}>
          {i18n.t(Translations.ChildSsnSkipModalChangeLater, { name: beneficiaryFirstName })}
        </Body>
        <div style={styles.rule} />
        <Caption style={styles.disclaimer}>
          {i18n.t(Translations.ChildSsnSkipModalDisclaimer)}
        </Caption>
      </div>
      <Spacing size={SpacingSizes.M} />
    </Overlay>
  );
};
